import useMediaQuery from '@mui/material/useMediaQuery'

import { useScreenSize } from './useScreenSize'

export const useWidgetHeaderStyles = (availableWidth?: number) => {
  const { isDesktop, isMobile, isSmallTablet, isTablet } = useScreenSize(availableWidth)
  const isViewportAbove900 = useMediaQuery('(min-width:900px)')

  const iconSize = 24

  // large variant
  // L & XL breakpoints
  let headerPaddingX = 48
  let headerPaddingTop = 32
  let headerPaddingBottom = 0
  let headerHeadingLevel: 'h1' | 'h2' | 'h3' = 'h1'
  let containerSquareCorners = false

  const isCompact = isMobile || isSmallTablet

  if (isTablet && !isSmallTablet) {
    // M breakpoint
    headerPaddingX = 24
    headerPaddingTop = 24
    headerHeadingLevel = 'h2'
  } else if (isCompact) {
    // small variant
    // S, XS, XXS breakpoints
    headerPaddingX = 8
    headerPaddingTop = 10
    headerPaddingBottom = 10
    headerHeadingLevel = 'h3'

    containerSquareCorners = true
  }

  const slotSx = {
    pb: isCompact ? 12 : 0,
    ...(isCompact && {
      px: headerPaddingX,
      '& .mx-cmn-date-range-selector': { m: 0, width: '100%' },
      '& .mx-cmn-date-range-selector > .MuiBox-root': { display: 'flex', justifyContent: 'center' },
      '& .MuiButtonGroup-root': { width: '100%' },
      '& .MuiButtonGroup-middleButton': { flex: 1 },
      '& .MuiToggleButtonGroup-root': { width: '100%', justifyContent: 'center' },
    }),
  }

  return {
    actionsFlex: isCompact ? 0 : 1,
    containerSquareCorners,
    headerHeadingLevel,
    headerPaddingBottom,
    headerPaddingTop,
    headerPaddingX,
    iconSize,
    isCompact,
    isDesktop,
    isViewportAbove900,
    slotSx,
  }
}
